import React from 'react';
import './aggregate-customer-traffic-config.scss';
import { AllReportsFieldsConfig } from './all-top10-columns-config';
import { capitalize, lowerCase } from 'lodash';
import { convertBytesUnitsCbForSaveDivideValue } from 'src/utils/convertBytesUnit';
import { NoResult } from 'src/components/shared/no-result/no-result';

export interface Traffic {
    data: Partial<AllReportsFieldsConfig>[] | undefined;
}

export const AggregateCustomerTraffic: React.FC<Traffic> = ({ data }: Traffic) => {
    const calcWidth = (numerator: number, denominator: number) => numerator * 100 / denominator;

    return <div className="traffic-widget">
        {!data?.length ? <NoResult /> :
            data.map((item, index) => {
                const { direction, bytes, bytes_received, bytes_sent } = item;
                if (!direction || bytes === undefined || bytes_received === undefined || bytes_sent === undefined) {
                    return null;
                }

                const convertBytesUnitsCb = convertBytesUnitsCbForSaveDivideValue(bytes);
                const result = convertBytesUnitsCb(bytes);
                const sentResult = convertBytesUnitsCb(bytes_sent);
                const receivedResult = convertBytesUnitsCb(bytes_received);
                return <div key={item.index || index} className="traffic-widget-direction">
                    <div className="title">
                        <div className="text">{capitalize(direction)}</div>
                        <div className={`icon ${lowerCase(direction).replaceAll(' ', '-')}`} />
                    </div>
                    <div className="total-amount"><span className="bigger-font">{result.value}{result.unitName}</span> Total</div>
                    <div className="bar-chart-wrapper">
                        <div className="bar-chart sent" style={{ width: `${calcWidth(bytes_sent, bytes)}%` }} />
                        <div className="bar-chart received" style={{ width: `${calcWidth(bytes_received, bytes)}%` }} />
                    </div>
                    <div className="info-wrapper">
                        <div className="info">
                            <div className="separation-dot sent" />
                            <div className="text">Bytes Sent </div>
                            <div className="bigger-font">{sentResult.value}{sentResult.unitName}</div>
                        </div>
                        <div className="info">
                            <div className="separation-dot received" />
                            <div className="text">Bytes Received </div>
                            <div className="bigger-font">{receivedResult.value}{receivedResult.unitName}</div>
                        </div>
                    </div>
                </div>;
            })}
    </div >;
};